var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mycoupon" }, [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showQR,
          expression: "showQR"
        }
      ],
      attrs: { id: "qrcode" },
      on: {
        click: function($event) {
          return _vm.handleClose()
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "titles" }, [
      _c(
        "div",
        {
          staticClass: "tabs",
          style: {
            color: _vm.active === 1 ? "#F2553D" : "#757575",
            borderBottom: _vm.active === 1 ? "solid 2px #F2553D" : "",
            height: "25px",
            background: "#ffffff"
          },
          on: {
            click: function($event) {
              return _vm.handleTab(1)
            }
          }
        },
        [_vm._v("\n      未使用\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tabs",
          style: {
            color: _vm.active === 2 ? "#F2553D" : "#757575",
            borderBottom: _vm.active === 2 ? "solid 2px #F2553D" : "",
            height: "25px"
          },
          on: {
            click: function($event) {
              return _vm.handleTab(2)
            }
          }
        },
        [_vm._v("\n      已使用\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tabs",
          style: {
            color: _vm.active === 3 ? "#F2553D" : "#757575",
            borderBottom: _vm.active === 3 ? "solid 2px #F2553D" : "",
            height: "25px"
          },
          on: {
            click: function($event) {
              return _vm.handleTab(3)
            }
          }
        },
        [_vm._v("\n      已过期\n    ")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _vm._l(_vm.noUse, function(item, index) {
          return _vm.active == 1
            ? _c("div", { key: item.id, staticClass: "noUse_item" }, [
                _c("div", { staticClass: "noUse_top" }, [
                  _c("div", { staticClass: "noUse_topOne" }, [
                    _c("p", { staticClass: "noUse_num" }, [
                      _vm._v("\n            ￥"),
                      _c("span", [
                        _vm._v(_vm._s(item.coupon.discountRule.discount))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "noUse_canUse" }, [_vm._v("优惠券")])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "noUse_center" }, [
                      _vm._v(_vm._s(item.coupon.name))
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 2,
                            expression: "item.coupon.validPeriodType === 2"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            领取后" +
                            _vm._s(item.coupon.validPeriodRule.duration) +
                            "天内有效\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 2,
                            expression: "item.coupon.validPeriodType === 2"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.moment(item.collectedAt).format("YYYY-MM-DD")
                            ) +
                            "-\n            " +
                            _vm._s(_vm.getCollectedValidTo(item)) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 1,
                            expression: "item.coupon.validPeriodType === 1"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm
                                .moment(item.coupon.validPeriodRule.from)
                                .format("YYYY-MM-DD")
                            ) +
                            "-\n            " +
                            _vm._s(
                              _vm
                                .moment(item.coupon.validPeriodRule.to)
                                .format("YYYY-MM-DD")
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "userules",
                        on: {
                          click: function($event) {
                            return _vm.showDetail(item)
                          }
                        }
                      },
                      [_vm._v("使用规则>")]
                    )
                  ]),
                  _vm._v(" "),
                  item.status != 3
                    ? _c(
                        "div",
                        {
                          staticClass: "useButton",
                          on: {
                            click: function($event) {
                              return _vm.handleClick(item)
                            }
                          }
                        },
                        [_vm._v("\n          立即使用\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.status == 3
                    ? _c("div", { staticClass: "useButton usedButton" }, [
                        _vm._v("未生效")
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.used, function(item) {
          return _vm.active == 2
            ? _c("div", { key: item.id, staticClass: "noUse_item" }, [
                _c("div", { staticClass: "noUse_top" }, [
                  _c("div", { staticClass: "noUse_topOne" }, [
                    _c("p", { staticClass: "noUse_num" }, [
                      _vm._v("\n            ￥"),
                      _c("span", [
                        _vm._v(_vm._s(item.coupon.discountRule.discount))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "noUse_canUse" }, [_vm._v("优惠券")])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "noUse_center" }, [
                      _vm._v(_vm._s(item.coupon.name))
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 2,
                            expression: "item.coupon.validPeriodType === 2"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            领取后" +
                            _vm._s(item.coupon.validPeriodRule.duration) +
                            "天内有效\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 2,
                            expression: "item.coupon.validPeriodType === 2"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.moment(item.collectedAt).format("YYYY-MM-DD")
                            ) +
                            "-\n            " +
                            _vm._s(_vm.getCollectedValidTo(item)) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 1,
                            expression: "item.coupon.validPeriodType === 1"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm
                                .moment(item.coupon.validPeriodRule.from)
                                .format("YYYY-MM-DD")
                            ) +
                            "-\n            " +
                            _vm._s(
                              _vm
                                .moment(item.coupon.validPeriodRule.to)
                                .format("YYYY-MM-DD")
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "userules",
                        on: {
                          click: function($event) {
                            return _vm.showDetail(item)
                          }
                        }
                      },
                      [_vm._v("使用规则>")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "useButton usedButton" }, [
                    _vm._v("已使用")
                  ])
                ])
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.pass, function(item) {
          return _vm.active == 3
            ? _c("div", { key: item.id, staticClass: "noUse_item" }, [
                _c("div", { staticClass: "noUse_top" }, [
                  _c("div", { staticClass: "noUse_topOne" }, [
                    _c("p", { staticClass: "noUse_num" }, [
                      _vm._v("\n            ￥"),
                      _c("span", [
                        _vm._v(_vm._s(item.coupon.discountRule.discount))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "noUse_canUse" }, [_vm._v("优惠券")])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "noUse_center" }, [
                      _vm._v(_vm._s(item.coupon.name))
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 2,
                            expression: "item.coupon.validPeriodType === 2"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            领取后" +
                            _vm._s(item.coupon.validPeriodRule.duration) +
                            "天内有效\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 2,
                            expression: "item.coupon.validPeriodType === 2"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.moment(item.collectedAt).format("YYYY-MM-DD")
                            ) +
                            "-\n            " +
                            _vm._s(_vm.getCollectedValidTo(item)) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.coupon.validPeriodType === 1,
                            expression: "item.coupon.validPeriodType === 1"
                          }
                        ],
                        staticClass: "noUse_centerTime"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm
                                .moment(item.coupon.validPeriodRule.from)
                                .format("YYYY-MM-DD")
                            ) +
                            "-\n            " +
                            _vm._s(
                              _vm
                                .moment(item.coupon.validPeriodRule.to)
                                .format("YYYY-MM-DD")
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "userules",
                        on: {
                          click: function($event) {
                            return _vm.showDetail(item)
                          }
                        }
                      },
                      [_vm._v("使用规则>")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "useButton usedButton" }, [
                    _vm._v("已过期")
                  ])
                ])
              ])
            : _vm._e()
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.details ? _c("div", { staticClass: "mask" }) : _vm._e(),
    _vm._v(" "),
    _vm.details
      ? _c("div", { staticClass: "detail_box" }, [
          _c("p", { staticClass: "usetit" }, [_vm._v("使用规则")]),
          _vm._v(" "),
          _c("div", { staticClass: "detail_content" }, [
            _vm.rules
              ? _c("p", { staticClass: "detail_p" }, [
                  _vm._v(_vm._s(_vm.rules))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.desc
              ? _c("p", { staticClass: "detail_p" }, [_vm._v(_vm._s(_vm.desc))])
              : _vm._e(),
            _vm._v(" "),
            _vm.shops
              ? _c("p", { staticClass: "detail_p" }, [
                  _vm._v(_vm._s(_vm.shops))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "agree",
              on: {
                click: function($event) {
                  return _vm.agrees()
                }
              }
            },
            [_vm._v("我知道了")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41d30f2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d30f2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/MyCoupon/index.vue
// module id = null
// module chunks = 